import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  InfoNotificationsService,
  InfoNotification,
} from 'src/app/services/info-notifications/info-notifications.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

export interface DeleteInfoNotificationDialogData {
  notification: InfoNotification;
}

@Component({
  selector: 'app-delete-info-notification-dialog',
  templateUrl: './delete-info-notification-dialog.component.html',
  styleUrls: ['./delete-info-notification-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent],
})
export class DeleteInfoNotificationDialogComponent {
  private dialogRef =
    inject<MatDialogRef<DeleteInfoNotificationDialogComponent, boolean>>(
      MatDialogRef,
    );
  private infoNotificationsService = inject(InfoNotificationsService);

  data = inject<DeleteInfoNotificationDialogData>(MAT_DIALOG_DATA);

  loading = false;
  errorMessage = '';

  readonly onSubmit = async () => {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    try {
      await this.infoNotificationsService.deleteInfoNotification(
        this.data.notification.id,
      );

      this.dialogRef.close(true);
    } catch (error) {
      console.error('Error deleting notification:', error);
      this.errorMessage = 'Hiba történt a törlés során. Kérjük, próbálja újra.';
    } finally {
      this.loading = false;
    }
  };

  readonly onCancel = () => {
    this.dialogRef.close(false);
  };
}
